import BaseCollection from "lib/collection";
import BaseModel from "lib/model";

const GenericModel = BaseModel.extend({
    idAttribute: "__name",
    props: {
        __name: "string",
        __id: "string",
    },
});

const Generic = BaseCollection.extend({
    mainIndex: "__name",
    model: GenericModel,
});

export default Generic;
